import { Record } from 'immutable';
import { Party } from '../../event/models/party';

const VendorSearchRequestRecord = Record({
  chain: null,
  brand: null,
  property: null,
  city: null,
  stateCode: null,
  countryCode: null,
  payorType: null,
  onlySubscribers: false,
  excludedParties: null
});

export class VendorSearchRequest extends VendorSearchRequestRecord {
  chain: string;
  brand: string;
  property: string;
  city: string;
  stateCode: string;
  countryCode: string;
  payorType: string;
  onlySubscribers: boolean;
  excludedParties: Party[];
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/vendor-search-request.ts